import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Box, Tab, Tabs } from '@mui/material'
import CardTitle from '../../Component/common/card/CardTitle'
import RegionList from './RegionList'
import CityList from './CityList'
import MUICard from '../../Component/common/card/MUICard'
import { getString } from '../../helper/util'

const tabSx = { fontSize: '14px', fontWeight: 700, textTransform: 'none' }

const VALUES_OF_TABS = {
    RegionList: 0,
    CityList: 1
}

export default function RegionCity() {

    const lang = useSelector((state) => state.lang.ui.lang)
    const theme = useSelector((state) => state.theme.ui.theme)

    const [tabIdx, setTabIdx] = useState(VALUES_OF_TABS.RegionList)
    const [filterRegionCode, setFilterRegionCode] = useState('')

    const onChangeTab = (_, newTabIdx) => setTabIdx(newTabIdx)

    const onClickLaunchCityList = (regionCode) => {
        setFilterRegionCode(regionCode)
        setTabIdx(VALUES_OF_TABS.CityList)
    }

    const renderTabsContent = () => {
        switch (tabIdx) {
            case VALUES_OF_TABS.RegionList:
                return <RegionList onClickLaunchCityList={onClickLaunchCityList} />
            case VALUES_OF_TABS.CityList:
                return <CityList newFilter={filterRegionCode ? { regionCode: filterRegionCode } : {}} />

            default:
                return null
        }
    }

    return (
        <MUICard header={<CardTitle>Region / City</CardTitle>}>
            <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Tabs value={tabIdx} onChange={onChangeTab} aria-label='tabs' sx={{ marginBottom: 1, borderBottom: 1, borderColor: 'divider' }}>
                    <Tab value={VALUES_OF_TABS.RegionList} label={getString(lang, undefined, 'region', theme)} sx={tabSx} />
                    <Tab value={VALUES_OF_TABS.CityList} label={getString(lang, undefined, 'city', theme)} sx={tabSx} />
                </Tabs>
                <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
                    {renderTabsContent()}
                </Box>
            </Box>
        </MUICard>
    )
}
